module.exports = __webpack_public_path__ + "media/images/athletes/50-b08b2fc23b59061efe8321ee1728f81b.png";